import { graphql } from "@/gql";

export const salesCommissionQueryGraphql = graphql(`
  query SalesCommissionReport($quarter: Int!, $year: Int!, $userId: ID) {
    salesCommissionReport(quarter: $quarter, year: $year, userId: $userId) {
      user {
        ...UserFields
      }
      quarter
      year
      totalRevenue
      commissionAmount
      bookingCount
      currency
      organisations {
        organisation {
          ...OrganisationFields
        }
        revenue
        commissionAmount
        bookingCount
      }
      trend {
        previousRevenue
        percentageChange
        isPartialComparison
      }
    }
  }
`);
